import React, { useState } from "react";
import axios from "axios";
import Successwithfeedbackmodal from "../shared/Successwithfeedbackmodal";
import FailureModal from "../shared/FailureModal";
// import CandidateDashboardNav from "./CandidateDashboardNav";
// import EmployerDashboardNav from "../employer/EmployerDashboardNav";

const ChangePhone = () => {
  const [newPhone, setNewphone] = useState(null);
  const [password, setPassword] = useState("");
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showFailureModal, setShowFailureModal] = useState(false);
  const [failureMessage, setFailureMessage] = useState("");
  const userid = localStorage.getItem("userid");
 // const usertype = localStorage.getItem("userType");

  const handlePhoneChange = async (e) => {
    e.preventDefault();

    if (!/^\d{10}$/.test(newPhone)) {
      setFailureMessage("Please enter a valid 10-digit phone number.");
      setShowFailureModal(true)
      return;
    }
try {
  const response = await axios.put(
    `${process.env.REACT_APP_API_URL}users/updateuserphone`,
    {
      userid,
      password,
      newPhone,
    },
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );

  if (response.status === 200) {
    setShowSuccessModal(true);
    setNewphone("");
    setPassword("");
  } else {
    setFailureMessage("Failed to update phone number.");
    setShowFailureModal(true);
  }
} catch (error) {
  if (error.response && error.response.status === 400) {
    setFailureMessage("Incorrect password. Please try again.");
  } else if(error.response && error.response.status === 401) {
    setFailureMessage("Phone number is same as Old Phone number");
  }else{
    setFailureMessage("Failed to update phone number. Please try again later.");
  }
  setShowFailureModal(true);
}
};
  return (
 
              <div class="user-profile-card">
                <h4 class="user-profile-card-title">Change Phone</h4>
                <div class="col-lg-12">
                  <div class="profile-form">
                    <form onSubmit={handlePhoneChange}>
                      <div class="form-group">
                        <label>New Phone Number</label>
                        <input
                          type="tel"
                          class="form-control"
                          placeholder="New Phone Number"
                          value={newPhone}
                          onChange={(e) => setNewphone(e.target.value)}
                        />
                      </div>
                      <div class="form-group">
                        <label>Password</label>
                        <input
                          type="password"
                          class="form-control"
                          placeholder="Enter your password"
                          value={password}
                          onChange={(e) => setPassword(e.target.value)}
                          required
                        />
                      </div>
                      <button type="submit" class="theme-btn mt-4">
                        Change Phone <i class="far fa-phone"></i>
                      </button>
                    </form>
                  </div>
                </div>
                <Successwithfeedbackmodal
                    show={showSuccessModal}
                    onClose={() => setShowSuccessModal(false)}
                    message="Phone number updated successfully!"
                  />
                  <FailureModal
                    show={showFailureModal}
                    onClose={() => setShowFailureModal(false)}
                    message={failureMessage}
                  />
              </div>
            
  );
};

export default ChangePhone;
